/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        try {
          const detail: string = error?.error?.errors?.[0]?.detail ?? '';
          if (detail.includes('JWT expired')) {
            this.router.navigate(['/auth/login']);
          }
        } catch {
          // Non-standard error shape (e.g. HTML error page, network failure)
        }
        return throwError(() => error);
      })
    );
  }
}
